import _merge from 'lodash/merge'
import { FolderORM, VERSION_UPDATE_STATUS, isCustomDeckORM } from 'src/types/types'
import { FilterAndSortOptions } from 'src/state/redux/selector/common'

export const merge: (
  ...args: FilterAndSortOptions<FolderORM>[]
) => FilterAndSortOptions<FolderORM> = (...args) => _merge({}, ...args)

enum FilterOption {
  active = 'active',
  archived = 'archived',
  notRemoved = 'notRemoved',
  rootFolder = 'rootFolder',
  shared = 'shared',
  isEligibleForDocumentUpgrade = 'isEligibleForDocumentUpgrade',
  isEligibleForCustomDeckUpgrade = 'isEligibleForCustomDeckUpgrade',
  pinned = 'pinned',
}

// [TODO] - Update using `satisfies` to get rid of manual key typing
export type Filters = Record<FilterOption, FilterAndSortOptions<FolderORM>>

export const filters: Filters = {
  active: {
    filter: { model: { status: 'ACTIVE' } },
  },
  archived: {
    filter: { model: { status: 'ARCHIVED' } },
  },
  notRemoved: {
    filter: { model: { status: (s) => s !== 'REMOVED' } },
  },
  rootFolder: {
    filter: { relations: { parentFolderORM: null } },
  },
  shared: {
    filter: { meta: { isSharedWithTheUser: true } },
  },
  isEligibleForDocumentUpgrade: {
    // [TODO] - Double check accuracy of this property
    filter: { meta: { version: (v) => v.containsOutdatedDocVer } },
  },
  isEligibleForCustomDeckUpgrade: {
    filter: {
      relations: {
        items: (i) => {
          return i.some(item => {
            const itemORM = item.relations.itemORM
            if (!isCustomDeckORM(itemORM)) return false

            return itemORM.meta.version.updateStatus === VERSION_UPDATE_STATUS.PENDING_MINOR
          })
        },
      },
    },
  },
  pinned: {
    filter: { meta: { isFavorite: true } },
  },
}

enum SortOption {
  folderTypeAsc = 'folderTypeAsc',
  pinnedAsc = 'pinnedAsc',
  nameAsc = 'nameAsc',
  updatedAtDesc = 'updatedAtDesc',
}

type Sorts = Record<SortOption, FilterAndSortOptions<FolderORM>>

// [TODO-BEAC-7732] - Should switch to metadata properties to keep consistent with other usage
export const sorts: Sorts = {
  folderTypeAsc: { sort: [{ type: 'desc' }] },
  pinnedAsc: {
    sort: [
      { meta: { isFavorite: 'asc' } },
      { model: { name: 'asc' } },
    ],
  },
  nameAsc: {
    sort: [{ model: { name: 'asc' } }],
  },
  updatedAtDesc: {
    sort: [{ model: { updatedAt: 'desc' } }],
  },
}

export const pagination: Record<string, FilterAndSortOptions<FolderORM>> = {
  top5: {
    paginate: {
      currentPage: 1,
      pageSize: 5,
    },
  },
}

export default {
  filters,
  sorts,
  merge,
  pagination,
}
